export enum TimeFormat {
  FORMAT_12 = 0,
  FORMAT_24 = 1,
}
export enum Period {
  AM = 0,
  PM = 1,
}

export function extractValidTime(time: string): string {
  if (!time) {
    return null;
  }

  let format: TimeFormat = TimeFormat.FORMAT_24;
  let period: Period = 0;
  time = time.toLowerCase();

  if (time.indexOf('am') >= 0) {
    format = TimeFormat.FORMAT_12;
    period = Period.AM;
  }
  if (time.indexOf('pm') >= 0) {
    format = TimeFormat.FORMAT_12;
    period = Period.PM;
  }

  time = time.replace(' ', '').replace('am', '').replace('pm', '').trim();
  let hour: number = null;
  let minutes: number = null;
  if (time.indexOf(':') >= 0) {
    const t = time.split(':');
    hour = +t[0].replace(/\D/g, '');
    minutes = +t[1].replace(/\D/g, '');
  } else {
    hour = +time.replace(/\D/g, '');
    minutes = 0;
  }

  if (format === TimeFormat.FORMAT_12 && period === Period.PM) {
    if (hour !== 12) {
      hour = hour + 12;
    }
  }

  if (format === TimeFormat.FORMAT_12 && period === Period.AM) {
    if (hour === 12) {
      hour = 0;
    }
  }
  return `${hour}:${minutes < 10 ? '0' + minutes : minutes}`;
}
